module.exports = __webpack_public_path__ + "static/media/reborn in red-budded saplings the tree grows again.6769e008.png";